
import E from 'wangeditor'
import config from '@/config'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
@Component
export default class Editor extends Vue {
  @Prop() value!: any
   $refs!: { editor: any }
  editor:any = null
  content = ''
  action = `${config.baseURL}/platformapi/upload/image`
  initEditor() {
    this.editor = new E(this.$refs.editor)

    // 配置工具栏（类似 Element UI 风格）
    this.editor.config.menus = [
      'head',
      'bold',
      'fontSize',
      'fontName',
      'italic',
      'underline',
      'strikeThrough',
      'indent',
      'lineHeight',
      'foreColor',
      'backColor',
      'link',
      'list',
      'justify',
      'quote',
      'emoticon',
      'image',
      'video',
      'table',
      'code',
      'splitLine',
      'undo',
      'redo'
    ]

    // 占位符
    this.editor.config.placeholder = '请输入内容'

    // 颜色配置（Element UI 蓝色系）
    this.editor.config.colors = [
      '#409eff',
      '#67c23a',
      '#e6a23c',
      '#f56c6c',
      '#909399',
      '#303133',
      '#606266'
    ]

    // 内容变化回调
    this.editor.config.onchange = (html:string) => {
      this.content = html
      this.$emit('input', html)
    }

    // 上传图片配置
    // 设置上传图片的请求头
    this.editor.config.uploadImgHeaders = {
      'token': this.$store.getters.token, // 你的 token
      'version': config.version
    }
    this.editor.config.uploadImgServer = this.action
    this.editor.config.uploadImgMaxSize = 2 * 1024 * 1024 // 2M
    this.editor.config.uploadFileName = 'file'
    this.editor.config.uploadImgParams = {
      cid: ''
    }
    this.editor.config.uploadImgHooks = {
      //    success: function(xhr) {
      //         console.log('success', xhr)
      //     },
      //     // 图片上传并返回了结果，但图片插入时出错了
      //     fail: function(xhr, editor, resData) {
      //         console.log('fail', resData)
      //     },
      customInsert: function (insertImgFn:any, result:any) {
        // result 即服务端返回的接口
        console.log('customInsert', result)

        // insertImgFn 可把图片插入到编辑器，传入图片 src ，执行函数即可
        insertImgFn(result.data.uri)
      }
    }
    this.editor.create()
    console.log('initEditor', this.value)
   
    // 设置初始内容
    if (this.value) {
         const value = this.cleanForWangEditor(this.value)
      this.editor.txt.html(this.cleanForWangEditor(value))
    }

  }
  cleanForWangEditor(html: string) {
    if (!html) return '<p><br></p>'

    // 先反转义
    let clean = this.unescapeRichText(html)

    // 移除 contenteditable
    clean = clean.replace(/\s*contenteditable="[^"]*"/g, '')

    // 使用 DOM 解析修复结构
    const div = document.createElement('div')
    div.innerHTML = clean

    // 修复 p 包裹块级元素
    const ps = div.querySelectorAll('p')
    ps.forEach(p => {
      const blockChildren = Array.from(p.children).filter(child => {
        return ['H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'DIV', 'P'].includes(child.tagName)
      })

      if (blockChildren.length > 0) {
        const parent:any = p.parentNode
        const fragment = document.createDocumentFragment()

        Array.from(p.childNodes).forEach(node => {
          fragment.appendChild(node.cloneNode(true))
        })

        parent.insertBefore(fragment, p)
        parent.removeChild(p)
      }
    })

    clean = div.innerHTML

    // 标准化空标签
    clean = clean.replace(/<<p>\s*<<\/p>/g, '<p><br></p>')
    clean = clean.replace(/<<br\s*\/?>\s*<<br\s*\/?>/g, '</p><p><br></p>')

    // 确保有合法根结构
    if (!clean.trim().match(/^<(p|h[1-6]|div|img|table)/)) {
      clean = '<p>' + clean + '</p>'
    }

    return clean || '<p><br></p>'
  }
  unescapeRichText(html: string) {
    if (!html) return ''

    // 检测是否是双重转义格式
    if (this.isDoubleEscaped(html)) {
      // 提取引号内的内容
      const match = html.match(/<<p>"(.*)"<<\/p>/s)
      if (match) {
        html = match[1]
      }
    }// 反转义 HTML 实体
    const textarea = document.createElement('textarea')
    textarea.innerHTML = html
    let result = textarea.value

    // 再次反转义（处理双重转义的情况）
    if (result.includes('&lt;') || result.includes('&gt;')) {
      textarea.innerHTML = result
      result = textarea.value
    }

    return result
  }
  isDoubleEscaped(html:string) {
    if (!html || typeof html !== 'string') return false

    const trimmed = html.trim()

    // 匹配 <p>"&lt;...&gt;"</p> 模式
    return /^<<p>"&lt;/.test(trimmed) && /&gt;"<<\/p>$/.test(trimmed)
  }
  getContent() {
    return this.editor?.txt.html() || ''
  }

  setContent(html:string) {
    this.editor?.txt.html(html)
  }
  mounted() {
    this.initEditor()
  }

  beforeDestroy() {
    this.editor?.destroy()
  }

}
